import styles from "./chatBotApiTest.module.css";

export const RequestConsole = ({ result, loading }) => {
  if (loading) {
    return (
      <div className={styles.console}>
        <p className={styles.empty}>Waiting for the server…</p>
      </div>
    );
  }

  if (!result) {
    return (
      <div className={styles.console}>
        <p className={styles.empty}>Fill the form and send a request. The request and the response show up here.</p>
      </div>
    );
  }

  const statusClass = result.status && result.status < 300 ? styles.statusOk : styles.statusFail;

  return (
    <div className={styles.console}>
      <div className={styles.block}>
        <div className={styles.blockHead}>
          <span>Request</span>
        </div>
        <pre className={styles.code}>{`POST /api/${result.url}\n\n${JSON.stringify(result.params, null, 2)}`}</pre>
      </div>

      <div className={styles.block}>
        <div className={styles.blockHead}>
          <span>Response</span>
          {result.status ? <span className={`${styles.status} ${statusClass}`}>HTTP {result.status}</span> : null}
        </div>
        {result.error ? <p className={styles.error}>{result.error}</p> : null}
        {result.data ? <pre className={styles.code}>{JSON.stringify(result.data, null, 2)}</pre> : null}
      </div>
    </div>
  );
};
